import { Component, OnInit, Input } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { UserService } from 'app/main/shared/services/user.service';
import { CommentService } from 'app/main/shared/services/comment.service';
import { LocalUserService } from 'app/main/shared/services/localUser';
import { StatusService } from 'app/main/shared/services/status.service';
import { MatSnackBar, MatDialog } from '@angular/material';

@Component({
  selector: 'todo-comments',
  templateUrl: './todo-comments.component.html',
  styleUrls: ['./todo-comments.component.scss'],
  providers: [
    StatusService,
    LocalUserService,
    CommentService
  ]
})
export class TodoCommentsComponent implements OnInit {
  @Input() mode: string;
  @Input() orgId: string;
  @Input() caseId: string;


  commentsLoading = true;
  isLoading = false;
  commentData = [];
  commentForm;
  error = null;
  userSubs = {};
  userSubList = [];

  isAddComment: boolean = false
  constructor(
    public dialog: MatDialog,
    public snackBar: MatSnackBar,
    private localUser: LocalUserService,
    private commentService: CommentService,
    private userService: UserService
  ) {

  }

  ngOnInit() {

    this.commentForm = new FormGroup({
      comment: new FormControl('')
    });


  }
  ngOnChanges() {
    this.getComments();
  }

  getComments() {
    this.isLoading = true;
    this.commentsLoading = true;
    this.commentData = [];
    if (this.caseId) {
      this.commentService.getComment(this.orgId, this.caseId)
        .subscribe(result => {
          this.commentData = result;
          this.getUserSubs();
        });
    }
  }

  addComment() {
    this.isLoading = true;
    this.error = null;
    let commentMessage = this.commentForm.controls.comment.value;

    if (commentMessage.length > 2 && this.caseId) {

      let caseComment = {
        user_id: this.localUser.getUserId(),
        organization_id: this.orgId,
        comment_for_id: this.caseId,
        commented_at: new Date(),
        type: 'PETITION_COMMENT',
        message: commentMessage
      };

      this.commentService.postComment(this.orgId, caseComment)
        .subscribe(result => {
          this.commentForm.controls.comment.setValue('');
          this.isAddComment = false
          this.getComments();
        });

    } else {
      this.isLoading = false;
      this.error = 'Message must be longer than 2 Characters';
    }
  }

  getUserSubs() {
    this.userSubs = {};

    for (let i = 0; i < this.commentData.length; i++) {
      let userSub = this.commentData[i].user_id;
      if (this.userSubs[userSub] === undefined) {
        this.userSubs[userSub] = {};
        this.userSubList.push(userSub);
      }
    }

    this.getUsers();
  }

  getUsers() {
    if (this.userSubList.length === 0) {
      this.commentsLoading = false;
      this.isLoading = false;
    } else {
      let userSub = this.userSubList[0];
      this.userSubList.shift();
      this.userService.getUser(userSub)
        .subscribe(result => {
          let user = {
            firstName: result.first_name,
            lastName: result.last_name,
            id: result.id
          };
          this.userSubs[userSub] = user;
          this.getUsers();
        });
    }
  }

  formatTime(unix) {

    let theDate = new Date(unix);

    let options = { hour12: true, hour: 'numeric', minute: 'numeric', month: 'numeric', day: 'numeric', year: 'numeric' };

    return theDate.toLocaleDateString('en-US', options);
  }

}



// WEBPACK FOOTER //
// ./src/app/main/content/common/todo-tab/components/todo-comments/todo-comments.component.ts